/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IPublicError } from './ckeditorcloudservicesservererror';

export default class CKEditorCloudServicesError extends Error {
	public constructor(
		message: string,
		public readonly context?: unknown,
		public readonly code: string | null = null,
		public readonly data: Record<string, unknown> = {}
	) {
		super( `cloud-services-internal-error: ${ message }` );

		// The name is important for integrators, thanks to it we were able to remove CKEditorError from our deps.
		this.name = 'CKEditorError';
	}

	public static fromPublicError( publicError: IPublicError ): CKEditorCloudServicesError {
		return new CKEditorCloudServicesError( _formatMessage( publicError ), publicError );
	}
}

function _formatMessage( publicError: IPublicError ): string {
	let errorMessage: string = `cloud-services-error: ${ publicError.message }`;

	if ( publicError.data ) {
		errorMessage += `\nError data: ${ JSON.stringify( publicError.data ) }`;
	}

	if ( publicError.explanation ) {
		errorMessage += `\nExplanation: ${ publicError.explanation }`;
	}

	if ( publicError.action ) {
		errorMessage += `\nAction: ${ publicError.action }`;
	}

	if ( publicError.traceId ) {
		errorMessage += `\nTraceId: ${ publicError.traceId }`;
	}

	if ( publicError.code ) {
		errorMessage += `\nCode: ${ publicError.code }`;
	}

	return errorMessage;
}
